const CookieBanner = () => {
  // TrustArc CCM is now enabled for all users
  return (
    <>
      <div id="consent_blackbar"></div>
    </>
  )
}

export default CookieBanner
